module.exports = __webpack_public_path__ + "fonts/NotoSansCJKkr-Medium.f3b73884.woff";